<div style="padding: 80px">
  <reports [subReports]="true"></reports>
</div>
